__turbopack_context__.v({
  "active": "annonces-switch-module__MxcD_q__active",
  "panel": "annonces-switch-module__MxcD_q__panel",
  "tabs": "annonces-switch-module__MxcD_q__tabs",
});
